import { t } from 'i18next';
import { HeadCell } from './invoicesClientTable.types';

export const headCells: HeadCell[] = [
  {
    id: 'code',
    numeric: false,
    label: t('code', { ns: 'invoice' }),
  },
  {
    id: 'jobCode',
    numeric: true,
    label: t('invoice.jobCode', { ns: 'reports' }),
  },
  {
    id: 'saleDate',
    numeric: true,
    label: t('saleDate', { ns: 'invoice' }),
    align: 'left',
  },
  {
    id: 'issueDate',
    numeric: true,
    label: t('issueDate', { ns: 'invoice' }),
    align: 'left',
  },
  {
    id: 'dueDate',
    numeric: true,
    label: t('dueDate', { ns: 'invoice' }),
    align: 'left',
  },
  {
    id: 'grossValue',
    numeric: true,
    label: t('grossAmount', { ns: 'priceItem' }),
    align: 'right',
  },
  {
    id: 'status',
    numeric: true,
    label: t('invoice.status.label', { ns: 'reports' }),
    align: 'justify',
  },
];

export const invoiceStatus = {
  PAID: t('paid', { ns: 'invoice' }),
  NOT_PAID: t('notPaid', { ns: 'invoice' }),
};

export const sortProperties = {
  id: 'id',
  code: 'code',
  jobCode: 'createdFrom.code',
  saleDate: 'saleDate',
  issueDate: 'issueDate',
  dueDate: 'dueDate',
  grossValue: 'totals.grossValue',
  status: 'paid',
  isCorrective: '',
};
